import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsGlobalViewsListRoute: InvariantJiraRoute = {
	name: 'polaris-settings-global-views-list',
	path: '/jira/settings/products/jira-product-discovery/global-views',
	exact: true,
};
